import { Button, Modal } from "react-bootstrap";
import { Dispatch, SetStateAction, useRef } from "react";
import { useRecoilState } from "recoil";
import { userInfoAtom } from "src/atoms";
import { update } from "src/service/user";
import useMyAccountModal from "src/hooks/Modal/MyAccount/useMyAccountModal";
import styles from "src/components/Console/MyAccount/MyAccount.module.scss";
import { useTranslation } from "react-i18next";
import { SubmitHandler, useForm } from "react-hook-form";
import FormErrorMessage from "../FormErrorMessage";
import "./MyAccount.style.scss";

interface IEditNameModalProps {
  showEditNameModal: boolean;
  setShowEditNameModal: Dispatch<SetStateAction<boolean>>;
}

type EditNameInputs = {
  newUserName: string;
};

const EditNameModal = ({
  showEditNameModal,
  setShowEditNameModal,
}: IEditNameModalProps) => {
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);

  const {
    handleSubmit,
    register,
    getValues,
    reset,
    formState: { errors },
  } = useForm<EditNameInputs>({
    defaultValues: {
      newUserName: "",
    },
    mode: "all",
  });

  const onSubmit: SubmitHandler<EditNameInputs> = async (data) => {
    const { newUserName } = data;
    const updUserInfo = { userName: newUserName } as const;
    try {
      const result = await update(updUserInfo);
      if (result) {
        // alert(t("navBar.myAccount.popUp.changeName.checkMsg4"));
        setUserInfo((prev) => ({ ...prev, userName: newUserName }));
      } else {
        // alert(t("navBar.myAccount.popUp.commonCheckMsg"));
      }
      setShowEditNameModal(false);
      reset();
    } catch (error: any) {
      // if (error?.errorCode && error?.errorMessage) {
      //   alert(error.errorMessage);
      // } else {
      //   alert(t("navBar.myAccount.popUp.commonCheckMsg"));
      // }
      setShowEditNameModal(false);
    }
  };

  return (
    <>
      <Modal
        show={showEditNameModal}
        onHide={() => setShowEditNameModal(false)}
        className="modal--sm"
        style={{ opacity: 1 }}
        centered
        dialogClassName={styles.modalDialogSm}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <h4 className={styles.modalHeaderTitle}>
              {t("navBar.myAccount.popUp.changeName.title")}
            </h4>
          </Modal.Header>
          <Modal.Body className={styles.modalBodySm}>
            <input
              {...register("newUserName", {
                required: "navBar.myAccount.popUp.changeName.checkMsg1",
                minLength: {
                  value: 3,
                  message: "navBar.myAccount.popUp.changeName.checkMsg2",
                },
                validate: (value) =>
                  value !== userInfo.userName ||
                  "navBar.myAccount.popUp.changeName.checkMsg3",
              })}
              id="newUserName"
              name="newUserName"
              type="text"
              autoComplete="off"
              maxLength={50}
              placeholder={t("navBar.myAccount.popUp.changeName.enterName")}
              className={`
            form-control ${
              errors.newUserName
                ? "form-textbox-invalid"
                : getValues("newUserName") !== ""
                ? "form-textbox-valid"
                : ""
            } custom-form mg mb-20`}
            />
            {errors.newUserName && (
              <FormErrorMessage
                errorMessage={errors?.newUserName?.message as string}
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className={`btn btn-gray ${styles.secondaryActionButton}`}
              onClick={() => setShowEditNameModal(false)}
            >
              {t("common.cancelBtn")}
            </Button>
            <Button type="submit" className={`${styles.primaryActionButton}`}>
              {t("common.okBtn")}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default EditNameModal;
